import React from 'react';

const Card = ({ className, children, style, ...props }) => {
    return (
        <div className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`} style={style} {...props}>
            {children}
        </div>
    );
};

export { Card };
